// extracted by mini-css-extract-plugin
export default {"phonebook__form":"App_phonebook__form__oytkp"};